var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.835938,
    width: 22.7106,
    height: 23.1827,
    rx: 5,
    fill: "#6564DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62305 10.0121C6.62305 9.7559 6.72274 9.51021 6.9002 9.32906C7.07767 9.14791 7.31835 9.04614 7.56932 9.04614H15.1395C15.3905 9.04614 15.6312 9.14791 15.8086 9.32906C15.9861 9.51021 16.0858 9.7559 16.0858 10.0121V14.8418C16.0858 15.098 15.9861 15.3437 15.8086 15.5248C15.6312 15.706 15.3905 15.8078 15.1395 15.8078H7.56932C7.31835 15.8078 7.07767 15.706 6.9002 15.5248C6.72274 15.3437 6.62305 15.098 6.62305 14.8418V10.0121Z",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.354 13.8759C12.1379 13.8759 12.7734 13.2272 12.7734 12.4269C12.7734 11.6267 12.1379 10.978 11.354 10.978C10.5701 10.978 9.93457 11.6267 9.93457 12.4269C9.93457 13.2272 10.5701 13.8759 11.354 13.8759Z",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1932 15.8078C14.1932 15.2954 14.3926 14.804 14.7476 14.4417C15.1025 14.0794 15.5839 13.8759 16.0858 13.8759M6.62305 10.978C7.12498 10.978 7.60636 10.7745 7.96128 10.4122C8.3162 10.0499 8.5156 9.55851 8.5156 9.04614L6.62305 10.978Z",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money_icon.bb9e7d081e2cca6b6b32f11bba687bb0.svg";
export { ForwardRef as ReactComponent };